import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function shipmentRate() {
    return {
        index,
        get,
        create,
        update,
        remove
    };
    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`tariff/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`tariff/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('tariff/create', data);
    }

    function update(data) {
        return axiosInstance.patch('tariff/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`tariff/delete`, {
            data: {
                id: id
            }
        });
    }
}
